<template>
  <section class="insu-desc">
    <h2 class="text-center mb-m section-title">{{ current.title }}</h2>
    <div class="mb-l insu-desc-cards-wrapper">      
      <InsuDescCard
        v-for="(desc, i) in current.descs"
        :key="i"
        :desc="desc"
      />
    </div>
  </section>
</template>

<script>
  import InsuDescCard from './InsuDescCard';
  import descs from '@/staticData/insuDescs';

  export default {
    components: { InsuDescCard },
    props: {
      type: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        descs
      };
    },
    computed: {
      current() {
        return this.type ? this.descs[this.type] : null;
      }
    }
  };
</script>